module.exports = __webpack_public_path__ + "media/newstyle/images/sentiment_stressed-de0d9d3130a7344d11ca70d676e80506.svg";